import { PageContainer, Card, Table, Button, Badge } from '@aimsos/ui';
import { LogOut } from 'lucide-react';

const SESSIONS = [
  { id: 1, user: 'alice@company.com', device: 'Chrome / macOS', ip: '192.168.1.10', location: 'New York, US', started: '2024-10-12 14:00', status: 'Active' },
  { id: 2, user: 'bob@company.com', device: 'Safari / iOS', ip: '10.0.0.5', location: 'Los Angeles, US', started: '2024-10-12 13:30', status: 'Active' },
  { id: 3, user: 'dave@company.com', device: 'Firefox / Windows', ip: '172.16.0.1', location: 'London, UK', started: '2024-10-12 10:15', status: 'Idle' },
];

const statusVariant = { Active: 'success', Idle: 'warning' };

const COLUMNS = [
  { key: 'user', label: 'User', sortable: true },
  { key: 'device', label: 'Device' },
  { key: 'ip', label: 'IP Address' },
  { key: 'location', label: 'Location' },
  { key: 'started', label: 'Started', sortable: true },
  {
    key: 'status',
    label: 'Status',
    render: (val) => <Badge variant={statusVariant[val] || 'default'}>{val}</Badge>,
  },
  {
    key: 'id',
    label: '',
    render: () => (
      <Button variant="ghost" size="sm" leftIcon={LogOut}>Revoke</Button>
    ),
  },
];

const Sessions = () => (
  <PageContainer
    title="Active Sessions"
    actions={
      <Button variant="danger" leftIcon={LogOut}>
        Revoke All Sessions
      </Button>
    }
  >
    <Card>
      <Card.Header
        title="Live Sessions"
        description={`${SESSIONS.length} active sessions`}
      />
      <Card.Body className="p-0">
        <Table columns={COLUMNS} data={SESSIONS} />
      </Card.Body>
    </Card>
  </PageContainer>
);

export default Sessions;
